const EDIT_APP_COMPANY_DOMAIN_DRAFT_PREFIX = 'admin:appCompanyDomainDraft:edit:'
export const NEW_APP_COMPANY_DOMAIN_DRAFT_KEY = 'admin:appCompanyDomainDraft:new'

const getSessionStorage = () => {
    if (typeof window === 'undefined') {
        return null
    }

    return window.sessionStorage
}

const normalizeTextValue = (value) => {
    if (value === undefined || value === null) {
        return ''
    }

    return String(value)
}

const normalizeNumberValue = (value, fallbackValue = 0) => {
    if (value === undefined || value === null || value === '') {
        return fallbackValue
    }

    const parsedValue = Number(value)

    return Number.isNaN(parsedValue) ? fallbackValue : parsedValue
}

// 기업 도메인 폼은 다시 선택 비용이 있는 기업과 도메인 문자열만 sessionStorage에 남긴다.
export const createAppCompanyDomainDraftPayload = ({ params = {} } = {}) => {
    return {
        params: {
            companyId: normalizeNumberValue(params.companyId, 0),
            domain: normalizeTextValue(params.domain),
        }
    }
}

// 서버 기본값 위에 draft만 덮어써서 새로고침 뒤에도 작성 흐름을 이어간다.
export const applyAppCompanyDomainDraft = ({ baseParams = {}, draft }) => {
    const normalizedBaseDraft = createAppCompanyDomainDraftPayload({
        params: baseParams,
    })

    if (!draft) {
        return {
            params: {
                ...baseParams,
                ...normalizedBaseDraft.params,
            },
        }
    }

    const draftParams = draft.params || {}

    return {
        params: {
            ...baseParams,
            companyId: draftParams.companyId === undefined
                ? normalizedBaseDraft.params.companyId
                : normalizeNumberValue(draftParams.companyId, normalizedBaseDraft.params.companyId),
            domain: draftParams.domain === undefined
                ? normalizedBaseDraft.params.domain
                : normalizeTextValue(draftParams.domain),
        }
    }
}

export const createEditAppCompanyDomainDraftKey = (companyDomainId) => `${EDIT_APP_COMPANY_DOMAIN_DRAFT_PREFIX}${companyDomainId}`

export const readAppCompanyDomainDraft = (draftKey) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return null
    }

    try {
        const storedValue = storage.getItem(draftKey)
        return storedValue ? JSON.parse(storedValue) : null
    } catch (_error) {
        return null
    }
}

export const saveAppCompanyDomainDraft = (draftKey, draftValue) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return
    }

    try {
        storage.setItem(draftKey, JSON.stringify(draftValue))
    } catch (_error) {
        // sessionStorage가 막혀 있어도 작성 흐름은 그대로 유지한다.
    }
}

export const clearAppCompanyDomainDraft = (draftKey) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return
    }

    try {
        storage.removeItem(draftKey)
    } catch (_error) {
        // storage 정리에 실패해도 화면 동작은 계속 진행한다.
    }
}
